'use client';

import { useFilters } from '../../context';
import FilterGroup from './FilterGroup';

/**
 * Filter component, conditionally renders filter sets available
 * against provider data.
 *
 * @return {*}
 */
const DataFilters = () => {
  const { filters } = useFilters();
  const hasContent = Object.values(filters).some(
    (group) => group?.filters?.length > 0
  );
  if (!filters || !hasContent) return null;

  return (
    <form
      data-testid="dataFilterContainer"
      onSubmit={(e) => e.preventDefault()}
      className="font-medium overflow-hidden w-80 min-w-60 max-w-80 h-full flex flex-col bg-transparent"
    >
      {Object.keys(filters).map((name) => {
        const group = filters[name];
        return <FilterGroup key={name} group={group} name={name} />;
      })}
    </form>
  );
};

export default DataFilters;
